export default "/_next/static/images/6f85571820e3814a35adb7217138ad93.jpg";